/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2022 ICEMEDX, Inc.
***********************************************/
import { provider_index } from "../domain/provider_index";
export class providerstat extends provider_index {
  public gettablename(): string {
    return "PROVIDER_STAT";
  }
}
